var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropDownIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.22172 1.21829C1.36498 1.08046 1.55709 1.00515 1.75586 1.0089C1.95462 1.01265 2.14376 1.09516 2.28172 1.23829L5.99172 5.17629L9.70172 1.23829C9.76915 1.16395 9.85083 1.1039 9.9419 1.0617C10.033 1.0195 10.1316 0.996005 10.2319 0.992615C10.3322 0.989226 10.4322 1.00601 10.5259 1.04196C10.6196 1.07792 10.7052 1.13232 10.7775 1.20195C10.8498 1.27157 10.9073 1.355 10.9468 1.44729C10.9863 1.53958 11.0068 1.63885 11.0072 1.73922C11.0076 1.83959 10.9879 1.93902 10.9491 2.03162C10.9104 2.12422 10.8535 2.2081 10.7817 2.27829L6.53172 6.77829C6.46175 6.85088 6.37787 6.90862 6.28509 6.94805C6.19231 6.98749 6.09253 7.00781 5.99172 7.00781C5.8909 7.00781 5.79112 6.98749 5.69834 6.94805C5.60556 6.90862 5.52168 6.85088 5.45172 6.77829L1.20172 2.27829C1.06389 2.13504 0.988571 1.94292 0.992321 1.74415C0.996071 1.54539 1.07858 1.35625 1.22172 1.21829Z",
    fill: "#9499A8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownIcon);
export default __webpack_public_path__ + "static/media/DropDownIcon.0d36c7a123a41dbe65039bf1e6599c8e.svg";
export { ForwardRef as ReactComponent };